import { config } from "../config";
import { callGateway, type CallerIdentity } from "./gateway";
import { SCOPE_FIELD } from "./reports";

/**
 * The numbers on the Welcome Page, from radreportsapi's POST /reports/summary
 * (v0.1.26, 2026-09-15). One call, one answer, the same scope contract as
 * every report: the tenant from the TOKEN, never from the UI.
 *
 * 🔑 Each count is the same population as the report its card links to --
 * the service counts with the same joins and predicates -- so a card and its
 * report cannot disagree. Revenue is summed server-side over IST calendar
 * periods (today, this week from Monday, this month from the 1st); the
 * answer carries the period starts it used so they can be checked.
 */
export const EXPIRING_WINDOW_DAYS = 5;

export interface Revenue {
  today: number;
  week: number;
  month: number;
  count: number;
  currency: string;
  day_start: string;
  week_start: string;
  month_start: string;
}

export interface Summary {
  namespace_prefix: string;
  as_of: string;
  active_plans: number;
  active_users: number;
  active_sessions: number;
  expiring_soon: number;
  expiring_window_days: number;
  revenue: Revenue;
}

export async function fetchSummary(identity: CallerIdentity, signal?: AbortSignal): Promise<Summary> {
  const r = await callGateway<Summary>(identity, config().gatewayBase, "/radreport/reports/summary", {
    method: "POST",
    body: { [SCOPE_FIELD]: identity.namespace, expiring_days: EXPIRING_WINDOW_DAYS },
    ...(signal ? { signal } : {}),
  });
  if (!r.data) throw new Error("The summary came back empty.");
  return r.data;
}

// ---- copy ------------------------------------------------------------------

export function greetingFor(hour: number): string {
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
}

const inr = new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 });
export const formatInr = (n: number) => inr.format(n);
export const formatCount = (n: number) => new Intl.NumberFormat("en-IN").format(n);
